module.exports = __webpack_public_path__ + "img/yijbml.15a68aec.png";